import React from "react";
import {
  CSP,
  ENCRYPT_STORAGE,
  WebLeft,
  WebTop,
  WebWidth,
} from "../../config/config";
import { F_Fammily, Font } from "../../util/config-fonts";
import { Colors } from "../../util/colors";
import { dto_common } from "../../classes/dto-common";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import {
  SET_STORE_DINE_TYPE,
  SET_STORE_PAGE_URL,
} from "../../database/store-data";
import { isMobile } from "react-device-detect";
import {
  GET_SET_STORED_DATA,
  Get_CustomerCSID,
  Get_CustomerDefaultAddress,
} from "../../database/get-stored-data";
import { PT_ADDRESSLIST, PT_SIGNIN } from "../../routes/stack/paths/pt-profile";
import "../../styles/css/fixed-header.css";
import { CONCAT_TEXT_LIMIT } from "../../functions/funtion";
import {
  PT_FILTER_OUTLETS_PRODUCTS,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import { STORE_DineType } from "../../database/store-names";

export default class HeaderHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ActiveIndex: 0,
      DisplayPickup: "block",
      PickupWidth: "50%",
      DisplayDelivery: "block",
      DeliveryWidth: "50%",
      DefaultAddress: "",
      CSID: 0,
    };
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    this.setState({
      DefaultAddress: await Get_CustomerDefaultAddress(),
      CSID: await Get_CustomerCSID(),
    });
    if (CSP === "MK") {
      await this.Setdinetype();
    }
  }

  render() {
    return (
      <>
        <div
          className="headerLayout fadeInDown animated"
          style={{
            position: "fixed",
            left: isMobile ? 0 : WebLeft,
            width: isMobile ? "100%" : WebWidth,
            top: isMobile ? 0 : WebTop,
            color: "black",
            zIndex: 1500,
            height: CSP !== "MK" ? 140 : 110,
            backgroundColor: "white",
          }}
        >
          {/* Zone */}
          <div
            className={CSP !== "MK" ? "merchantBG" : ""}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black",
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            {" "}
            {CSP !== "MK" ? (
              <>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: Font.Heading,
                    fontFamily: F_Fammily.Medium,
                    cursor: "pointer",
                  }}
                  id="ZoneHomeScreen"
                />

                <i
                  className="fa fa-caret-down"
                  aria-hidden="true"
                  style={{ marginLeft: 10, cursor: "pointer" }}
                />
              </>
            ) : null}
          </div>

          {/* Address */}
          <div
            className="commonWrap"
            style={{
              marginTop: CSP !== "MK" ? -15 : 15,
              color: "black",
            }}
          >
            <div
              className="addressBar"
              style={{
                cursor: "pointer",
                paddingLeft: CSP !== "MK" ? "10px " : 0,
                backgroundColor: CSP === "MK" ? "rgb(240, 240, 240)" : "none",
              }}
              onClick={() => this.OpenAddress()}
            >
              <i
                className="fa fa-map-marker"
                aria-hidden="true"
                style={{
                  paddingLeft: CSP === "MK" ? "20px" : 0,
                }}
              />

              <p style={{ margin: 4 }}>
                {CONCAT_TEXT_LIMIT({
                  length: 35,
                  string: this.state.DefaultAddress,
                })}
              </p>

              <i
                className="fa fa-caret-down"
                aria-hidden="true"
                style={{ marginLeft: 10, cursor: "pointer" }}
              />
            </div>
          </div>

          {/* OLD - dine type and filter */}
          <div
            className="commonWrap"
            style={{
              display: CSP === "MK" ? "flex" : "none",
            }}
          >
            <div
              className="btnHeader"
              style={{
                fontFamily: F_Fammily.Medium,
                width: this.state.DeliveryWidth,
                cursor: "pointer",
                backgroundColor:
                  this.state.ActiveIndex === 0 ? Colors.ThemeBGcolor : "white",
                color:
                  this.state.ActiveIndex === 0 ? "white" : Colors.ThemeBGcolor,
                display: this.state.DisplayDelivery,
              }}
              onClick={() => {
                dto_common.DineType = 4;
                ENCRYPT_STORAGE.removeItem("MerChantData");
                SET_STORE_DINE_TYPE(4);
                this.setState({ ActiveIndex: 0 });
                var button = document.getElementById("HomeScreenLoadEventCall");
                if (button) {
                  if (dto_StartupPageLoadInfo.isDineTypeButtonCall === true) {
                    button.click();
                  }
                }
              }}
            >
              <p>DELIVERY</p>
            </div>
            <div
              className="btnHeader"
              style={{
                fontFamily: F_Fammily.Medium,
                width: this.state.PickupWidth,
                cursor: "pointer",
                backgroundColor:
                  this.state.ActiveIndex === 1 ? Colors.ThemeBGcolor : "white",
                color:
                  this.state.ActiveIndex === 1 ? "white" : Colors.ThemeBGcolor,
                display: this.state.DisplayPickup,
              }}
              onClick={() => {
                dto_common.DineType = 3;
                ENCRYPT_STORAGE.removeItem("MerChantData");
                this.setState({ ActiveIndex: 1 });
                SET_STORE_DINE_TYPE(3);

                var button = document.getElementById("HomeScreenLoadEventCall");
                if (button) {
                  if (dto_StartupPageLoadInfo.isDineTypeButtonCall === true) {
                    button.click();
                  }
                }
              }}
            >
              <p>PICK UP</p>
            </div>

            <div
              className="addSearch"
              style={{
                cursor: "pointer",
                display: "block",
              }}
              onClick={() => {
                this.props.navigate(
                  PT_FILTER_OUTLETS_PRODUCTS.replace(":frmpath", "home"),
                );
              }}
            >
              <i className="fa fa-search" aria-hidden="true" />
            </div>
          </div>

          {/* NEW - filter */}
          <div
            className="commonWrap"
            style={{
              marginTop: CSP !== "MK" ? 10 : 15,
            }}
            onClick={() => {
              this.props.navigate(
                PT_FILTER_OUTLETS_PRODUCTS.replace(":frmpath", "home"),
              );
            }}
          >
            <div
              className="addressBar"
              style={{
                display: CSP !== "MK" ? "flex" : "none",
                backgroundColor: "rgb(240, 240, 240)",
                paddingLeft: CSP !== "MK" ? "20px " : 0,
                paddingTop: CSP !== "MK" ? "20px " : 0,
                paddingBottom: CSP !== "MK" ? "20px " : 0,
              }}
            >
              <i className="fa fa-search" aria-hidden="true" />
              <p style={{ margin: 4 }}>Search Merchants and Products</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  async Setdinetype() {
    let DineType = ENCRYPT_STORAGE.getItem(STORE_DineType);

    if (dto_StartupPageLoadInfo.DisplayDineType === 0) {
      if (DineType !== undefined) {
        if (DineType === 4) {
          dto_common.DineType = 4;
          SET_STORE_DINE_TYPE(4);
          this.setState({ ActiveIndex: 0 });
        }
        if (DineType === 3) {
          dto_common.DineType = 3;
          SET_STORE_DINE_TYPE(3);
          this.setState({ ActiveIndex: 1 });
        }
      }
    }

    if (dto_StartupPageLoadInfo.DisplayDineType === 4) {
      dto_common.DineType = 4;

      SET_STORE_DINE_TYPE(4);
      this.setState({
        DisplayPickup: "none",
        PickupWidth: "50%",
        DisplayDelivery: "block",
        DeliveryWidth: "90%",
        ActiveIndex: 0,
      });
    } else if (dto_StartupPageLoadInfo.DisplayDineType === 3) {
      SET_STORE_DINE_TYPE(3);
      dto_common.DineType = 3;
      this.setState({
        DisplayPickup: "block",
        PickupWidth: "90%",
        DisplayDelivery: "none",
        DeliveryWidth: "50%",
        ActiveIndex: 1,
      });
    } else if (dto_StartupPageLoadInfo.DisplayDineType === 0) {
      if (DineType === undefined) {
        SET_STORE_DINE_TYPE(4);
        dto_common.DineType = 4;
        this.setState({
          DisplayPickup: "block",
          PickupWidth: "45%",
          DisplayDelivery: "block",
          DeliveryWidth: "45%",
          ActiveIndex: 0,
        });
      }
    } else {
      if (DineType === undefined) {
        dto_common.DineType = 4;
        SET_STORE_DINE_TYPE(4);
        this.setState({
          DisplayPickup: "none",
          PickupWidth: "45%",
          DisplayDelivery: "none",
          DeliveryWidth: "45%",
          ActiveIndex: 0,
        });
      }
    }
  }

  async OpenAddress() {
    if (this.state.CSID !== 0) {
      await SET_STORE_PAGE_URL(PT_HOME);
      this.props.navigate(PT_ADDRESSLIST.replace(":frompage", "home"));
    } else {
      await SET_STORE_PAGE_URL(PT_HOME);
      this.props.navigate(PT_SIGNIN);
    }
  }
}
